import LoadingOverlay from "../../../../components/LoadingOverlay";
import { T2 } from "../../../../styles/titles";
import { Container } from "../../styles";
import { FormFilter } from "./components/filter/filters";
import React, { useEffect, useState } from "react";
import { Totals } from "./components/totals/totals";
import { AnticipationTableData, TotalsData } from "./types";
import { LiveTable } from "./components/liveTable/liveTable";
import AnticipationService from "./service/AnticipationService";
import AnticipationFeeService from "../../anticipationFees/anticipationFeeMenu/service/AnticipationFeeService";
import { AnticipationFeeData } from "../../anticipationFees/anticipationFeeMenu/types";

const Anticipation: React.FC = () => {
  const [filterData, setFilterData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [totals, setTotals] = useState<TotalsData | null>(null);
  const [tableData, setTableData] = useState<AnticipationTableData>({
    records: [],
    count: 0,
  });
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const anticipationService = new AnticipationService();
  const anticipationFeeService = new AnticipationFeeService();
  const [anticipationFee, setAnticipationFee] = useState<AnticipationFeeData>({
    adValorem: 0,
    dailyIof: 0,
    additionalIof: 0,
    operationFee: 0,
  });

  const fetchAnticipationFee = async () => {
    setIsLoading(true);

    try {
      const anticipationFeeData =
        await anticipationFeeService.getAnticipationFees();
      setAnticipationFee({
        adValorem: anticipationFeeData.adValorem,
        dailyIof: anticipationFeeData.dailyIof,
        additionalIof: anticipationFeeData.additionalIof,
        operationFee: anticipationFeeData.operationFee,
      });
    } catch (error) {
      console.log("Erro ao buscar as taxas de antecipação: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAnticipationFee();
  }, []);

  console.log(anticipationFee);

  const refreshPage = async (status: boolean) => {
    if (status) {
      await fetchAllData();
    }
  };

  const fetchAllData = async () => {
    setIsLoading(true);
    try {
      const [response] = await Promise.all([
        anticipationService.getReceivablesToAnticipate(filterData),
      ]);

      setTableData({
        records: response.records || [],
        count: response.countRecords || 0,
      });

      setTotals({
        totalLiquid: response.totalLiquidValue || 0,
        totalGrossValue: response.totalGrossValue || 0,
        totalSelect: 0,
        totalAnticipated: 0,
      });

      setCurrentPage(1);
    } catch (error) {
      console.error("Erro ao buscar dados: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!filterData) return;
    fetchAllData();
  }, [filterData]);

  // useEffect(() => {
  //   if (!filterData || currentPage === 1) return;
  //   fetchRecebiveis();
  // }, [currentPage, pageSize]);

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />

      <T2>Antecipação Pontual</T2>
      {totals && <Totals data={totals} />}
      <FormFilter getFilters={(data) => setFilterData(data)} />
      {tableData && (
        <LiveTable
          data={tableData}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={setPageSize}
          onSaveChanges={refreshPage}
          anticipationFees={anticipationFee}
          merchantId={filterData?.MerchantId ?? filterData?.merchantId ?? ""}
        />
      )}
    </Container>
  );
};

export default Anticipation;
